import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow_drop_down",
  "use": "arrow_drop_down-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow_drop_down\">\r\n<path d=\"M7 10L12 15L17 10H7Z\" fill=\"#3A3A3A\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol